<template>
  <v-menu
    v-model="datePickerMenu"
    ref="datePicker"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        ref="field"
        v-model="formattedDate"
        persistent-hint
        color="black"
        :clearable="clearable"
        :label="label"
        :rules="allRules"
        @input="setDate()"
        @click:clear="isoDate = ''"
        @keydown.tab="datePickerMenu = false"
      >
        <template #append>
          <v-icon v-on="on" color="primary" tabindex="-1">mdi-calendar</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      color="primary"
      v-model="isoDate"
      dark
      header-color="black"
      width="290"
      no-title
      @click:date="datePicked"
    />
  </v-menu>
</template>

<script>
import moment from 'moment'
import fieldRules from '@/utils/rules.js'

export default {
  name: 'CompactDatePicker',

  props: {
    initialDate: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: undefined
    },
    rules: {
      type: Array,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    datePickerMenu: false,
    isoDate: '',
    formattedDate: ''
  }),

  computed: {
    allRules () {
      return [...(this.rules ?? []), v => !v || fieldRules.rules.validDate(v)]
    }
  },

  watch: {
    isoDate (val) {
      if (val === '') {
        this.$emit('date-picked')
      } else {
        this.$emit('date-picked', moment(val).format())
      }
    }
  },

  created () {
    if (this.initialDate === '' || !this.initialDate) return
    this.isoDate = moment.utc(this.initialDate).local().format()
    this.formattedDate = moment(this.isoDate).format('MM/DD/YY')
  },

  methods: {
    datePicked (val) {
      this.formattedDate = moment(val).format('MM/DD/YY')
      this.datePickerMenu = false
    },

    setDate () {
      const text = this.formattedDate ?? ''
      this.isoDate = fieldRules.rules.validDate(text) === true ? moment(text, 'M/D/YY').format() : ''
    }
  }
}
</script>
